import { ArrowUpRight } from "lucide-react";

const SERVICIOS = [
    {
        id: "obras-civiles",
        title: "Ejecución de Obras Civiles",
        desc: "Nuestra ejecución abarca desde el movimiento de suelos y fundaciones hasta el montaje de cubiertas y terminaciones. Nos enfocamos en brindar soluciones integrales.",
        img: "https://images.pexels.com/photos/6034140/pexels-photo-6034140.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        span: "lg:col-span-2 lg:row-span-2",
        size: "large",
    },
    {
        id: "mantenimiento",
        title: "Mantenimiento Industrial",
        desc: "Especialistas en el mantenimiento técnico de infraestructura industrial. Implementamos soluciones preventivas y correctivas para asegurar la integridad operativa de su planta, evitando paradas por fallas en edilicias o instalaciones de soporte.",
        img: "https://images.pexels.com/photos/10290629/pexels-photo-10290629.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        span: "",
    },
    {
        id: "infraestructura-energia",
        title: "Mantenimiento de Infraestructura de Transporte de Energía",
        desc: "Realizamos mantenimiento preventivo, control de corrosión, control de fugas, mantenimiento de traza, y reparaciones correctivas bajo estrictas normas de seguridad.",
        img: "/energia-gasoducto.jpg",
        span: "",
    },
    {
        id: "steel-framing",
        title: "Steel Framing",
        desc: "Sistema constructivo en seco, rápido y de alta eficiencia energética.",
        img: "https://images.unsplash.com/photo-1767238456649-bf174a066368?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxzdGVlbCUyMGZyYW1pbmclMjBtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3Nzc0MDY0MDB8MA&ixlib=rb-4.1.0&q=85",
        span: "",
    },
    {
        id: "instalaciones",
        title: "Instalaciones de Alto Rendimiento",
        desc: "Eléctricas, hidráulicas, gas y climatización ejecutadas bajo normativa y certificaciones.",
        img: "https://images.pexels.com/photos/7178310/pexels-photo-7178310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        span: "",
    },
    {
        id: "vivienda-modular",
        title: "Vivienda Modular",
        desc: "Casas industrializadas con plazos predecibles, terminaciones modernas y eficiencia energética.",
        img: "https://images.unsplash.com/photo-1659259540441-c441d92eb460?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxtb2R1bGFyJTIwaG91c2UlMjBleHRlcmlvciUyMG1vZGVybnxlbnwwfHx8fDE3Nzc0MDY0MDl8MA&ixlib=rb-4.1.0&q=85",
        span: "",
    },
];

function ServiceCard({ s, idx }) {
    const isLarge = s.size === "large";
    return (
        <a
            href="#contacto"
            data-testid={`service-card-${s.id}`}
            className={`bento-card group block relative ${s.span || ""} ${isLarge ? "min-h-[420px]" : "min-h-[260px]"}`}
        >
            <div className="absolute inset-0">
                <img
                    src={s.img}
                    alt={s.title}
                    className="bento-img w-full h-full object-cover"
                    style={{ filter: "grayscale(40%)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/55 to-transparent" />
            </div>

            <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
                <div className="flex items-start justify-between">
                    <span className="text-[10px] uppercase tracking-[0.25em] text-white/60">
                        0{idx + 1}
                    </span>
                    <span className="w-9 h-9 border border-white/30 flex items-center justify-center text-white group-hover:bg-[#14888F] group-hover:border-[#14888F] group-hover:text-white transition-all">
                        <ArrowUpRight size={16} />
                    </span>
                </div>
                <div>
                    <h3 className={`${isLarge ? "text-2xl md:text-4xl" : "text-xl md:text-2xl"} font-black text-white uppercase leading-tight`} style={{ fontFamily: "Chivo" }}>
                        {s.title}
                    </h3>
                    <p className="mt-3 text-sm text-white/70 max-w-md leading-relaxed">
                        {s.desc}
                    </p>
                </div>
            </div>
        </a>
    );
}

export default function Servicios() {
    return (
        <section id="servicios" className="relative py-24 md:py-32 bg-[#0A0A0A] border-t border-[#1a1a1a]" data-testid="servicios-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <p className="overline" data-testid="servicios-overline">Servicios</p>
                        <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.95]" style={{ fontFamily: "Chivo" }} data-testid="servicios-title">
                            Soluciones <span className="text-[#14888F]">integrales</span>
                            <br /> para cada obra.
                        </h2>
                    </div>
                    <p className="text-white/65 max-w-md text-base leading-relaxed">
                        Desde la ingeniería de detalle hasta la ejecución llave en mano, cubrimos todo el ciclo del proyecto con estándares industriales.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-3 gap-4 md:gap-5" data-testid="servicios-grid">
                    {SERVICIOS.map((s, i) => (
                        <ServiceCard key={s.id} s={s} idx={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
